























import router from '@/router';
import {Component, Vue} from 'vue-property-decorator';

@Component
export default class EmptyPageView extends Vue {
  public updatePage() {
    router.push(this.address);
  }

  info!: string;

  address!: string;

  addrErr!: string;

  method!: string;

  created() {
    this.info = this.$route.params.info;
    this.address = this.$route.params.address;
    this.addrErr = this.$route.params.addrErr;
    this.method = this.$route.params.method;
  }
}
